import { SET_BULK_OPERATIONS_STATUS } from "./BulkOperationStatusActionTypes"


export type BulkOperationsStatusStore = {
    BulkOperationsStatus:string
}

const defaultState: BulkOperationsStatusStore = {
    BulkOperationsStatus:"completed"
}

function bulkOperationsStatusReducer(state = defaultState, action) {
    switch(action.type) {
    case SET_BULK_OPERATIONS_STATUS:
        state.BulkOperationsStatus = action.payload.BulkOperationsStatus
        return {...state}
    default:
        return state
    }
}

export default bulkOperationsStatusReducer


// WEBPACK FOOTER //
// ./src/state/bulk-operation/BulkOperationStatusReducer.ts